import React, { createContext, useContext, ReactNode, useState } from 'react';
import { CurrentRefinementsConnectorParamsItem } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';
import { Category } from 'shared/types/product/Category';

interface Facets {
  [key: string]: string;
}

interface ColorsForBadge {
  discount?: string;
  new?: string;
  bestSeller?: string;
  upto5x?: string;
  promo?: string;
}
interface CollapsedFacetList {
  [key: string]: string[];
}
export interface ProductListingContextType {
  slug: string | undefined;
  searchQuery: string;
  categoryHit: any;
  sortByOptions: { label: string; value: string }[];
  categories?: Category[]; // Adjust the type according to your category structure
  facets: Facets;
  showTopCategories: boolean;
  colorsForBadge: ColorsForBadge;
  loading: boolean;
  setLoading: any;
  brandName: string | undefined;
  pageType: string | undefined;
  managedContent: Content;
  managedBottomContent: Content;
  applyCategoryFilter: boolean;
  screenSizeView: string | undefined;
  blpExcludedFacets: string[];
  appliedFilters: CurrentRefinementsConnectorParamsItem[];
  setAppliedFilters: any;
  collapsedFacetList: CollapsedFacetList;
  seoFacetTitle?: string;
  seoFacetTitleFlag?: boolean;
  schemaOverride?: any;
  expandedFacetList?: any;
}

interface Content {
  contentTitle?: string;
  showContent?: boolean;
}

// Create a context with default values
const ProductListingContext = createContext<ProductListingContextType>({
  slug: '',
  searchQuery: '',
  sortByOptions: [],
  categories: [],
  categoryHit: [],
  facets: {},
  showTopCategories: false,
  colorsForBadge: {},
  loading: false,
  setLoading: () => {},
  brandName: '',
  pageType: '',
  managedContent: {},
  managedBottomContent: {},
  applyCategoryFilter: false,
  screenSizeView: '',
  blpExcludedFacets: [],
  appliedFilters: [],
  setAppliedFilters: () => {},
  collapsedFacetList: {},
  seoFacetTitle: '',
  seoFacetTitleFlag: false,
  expandedFacetList: [],
});

export const useProductListingContext = () => useContext(ProductListingContext);

interface ProductListingProviderProps {
  children: ReactNode;
  value: ProductListingContextType;
}

export const ProductListingProvider: React.FC<ProductListingProviderProps> = ({ children, value }) => {
  const [loading, setLoading] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  return (
    <ProductListingContext.Provider value={{ ...value, loading, setLoading, appliedFilters, setAppliedFilters }}>
      {children}
    </ProductListingContext.Provider>
  );
};
